module.exports = __webpack_public_path__ + "static/media/question-circle.0b26d263.svg";